/**
 * 自定义组件参考文档
 * https://cn.vuejs.org/v2/guide/components-registration.html
*/
import Vue from 'vue'
import test from './test/';
import StraightLine from './StraightLine/';
import VerticalLine from './VerticalLine/';
import Rectangle from './Rectangle/';
import Round from './Round/';
import Navigation from './Navigation/';
import ProductList from './ProductList/';
import DeviceList from './DeviceList/';
import DeviceProperty from './DeviceProperty/';
import DeviceGroup from './DeviceGroup/';
import DeviceStatus from './DeviceStatus/';
import ComponentTitle from './ComponentTitle/';
import WeekSchedule from './WeekSchedule/';
import Dmap from './3Dmap/';
import DeviceMap from './DeviceMap/';

import components from '@/components/core/ui/index'
import { installEchartsOptionRuntime } from '@/runtime/echarts-option-runtime'
import { installDeviceChartRuntime } from '@/runtime/device-chart-runtime'
import { installDeviceValueRuntime } from '@/runtime/device-value-runtime'
import { installDraggableKeyboardGuard } from '@/runtime/draggable-keyboard'
import { installProgressPresentation } from '@/runtime/progress-presentation'
import { installTextMetricRuntime } from '@/runtime/text-metric'
import { installImageFrameRuntime } from '@/runtime/image-frame'
// 扩展原有图表实例，不注册新的图表组件或改变组件名称。
installEchartsOptionRuntime(Vue)
installDeviceChartRuntime(Vue)
installDeviceValueRuntime(Vue)
installDraggableKeyboardGuard(Vue)
installImageFrameRuntime(Vue)
installTextMetricRuntime(Vue)
installProgressPresentation(Vue)
const list = [
  test,
  Dmap,
  DeviceMap,
  StraightLine,
  VerticalLine,
  Rectangle,
  Round,
  Navigation,
  ProductList,
  DeviceList,
  DeviceProperty,
  DeviceGroup,
  DeviceStatus,
  ComponentTitle,
  WeekSchedule,
]
//循环注册组件
// 图片型旧地图沿用原渲染器；本次仅替换地理边界型地图，旧项目不丢图片地图能力。
const legacyMap = Vue.options.components['avue-echart-map']
if (legacyMap) Vue.component('avue-echart-legacy-map', legacyMap)
list.forEach(ele => {
  Vue.component(ele.name, ele)
})
//自定义组件
Object.keys(components).map(ele => {
  let component = components[ele];
  Vue.component(component.name, component);
});
